import React, { useEffect, useRef, useState } from "react";
import { Col, Collapse, Form, Radio, Row, Tabs, Modal } from "antd";
import Guarantor from "./Guarantor";
import { RequiredFields } from "../../common/RequiredFields";
import {
  checkValidations,
  hasKeysAndNotEmpty,
  validateRequiredFields,
} from "../../common/Utilities";
import { toast } from "react-toastify";
import axios from "../../axios/axios";
import { useDispatch, useSelector } from "react-redux";
import { addGuarantor, removeGuarantor, removeGuarantorLabelByModal, resetGuarantors } from "../../redux/slice/guarantorInfoSlice";

const GuarantorTabs = (props) => {
  const {
    updateFunction,
    guarantorCountUpdator,
    isApplicationGuarantor,
    applicationID,
    existingGuarantors,
    clickAddBtn,
    setClickAddBtn
  } = props;
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState(1);
  const [remModal, setRemModal] = useState(false);
  const [remTrgt, setRemTrgt] = useState("");
  const initialItems = [
    {
      label: "Guarantor 1",
      children: (
        <Guarantor
          guarantor_index={1}
          updateFunction={updateFunction}
          isApplicationGuarantor={isApplicationGuarantor}
          applicationID={applicationID}
          existingGuarantors={existingGuarantors}
        />
      ),
      key: 1,
    },
  ];

  const [items, setItems] = useState([]);
  const { guarantorButtonId, minIncome, guarantorButtonTime } = useSelector((state) => state.guarantorInfo);
  const tabStatus = sessionStorage.getItem("singPassStatus");

  const onChange = (e) => {
    setActiveKey(e);
    localStorage.setItem("storeCurrentTab", e)
  };

  useEffect(() => {
    const cutrrentTabCounts = parseInt(localStorage.getItem("storeCurrentTab")) || 1;
    if (tabStatus == 'true') {
      setActiveKey(cutrrentTabCounts);
      onChange(cutrrentTabCounts);
      sessionStorage.removeItem("singPassStatus");
    }
  }, [tabStatus]);


  useEffect(() => {
    if (guarantorButtonTime) {
      if (clickAddBtn == true) {
        dispatch(addGuarantor({ guarantorButtonId, minIncome }));
        handleGuarantorClick();
      } else {
        dispatch(addGuarantor({ guarantorButtonId, minIncome }));
        add();
      }
    }
  }, [guarantorButtonTime]);

  const add = () => {
    const newPanes = [...items];
    const actualLength = items.length;
    const newLength = items.length + 1;
    if (newLength <= 4) {
      let savedGuarantorData = JSON.parse(
        localStorage.getItem("guarantor_details_" + actualLength)
      );
      let savedGuarantorDetails = JSON.parse(
        localStorage.getItem("guarantor_personal_details_" + actualLength)
      );
      let savedGuarantorEmployemnt = JSON.parse(
        localStorage.getItem("guarantor_employement_details_" + actualLength)
      );
      let savedGuarantorDocuments = JSON.parse(
        localStorage.getItem("guarantor_documents_" + actualLength)
      );
      let completionResultData = false;
      let completionResultEmployemnt = false;
      let completionResultDocuments = false;
      let validationResult = false;
      let validationCompletion = false;
      if (
        !savedGuarantorData ||
        !savedGuarantorDetails ||
        !savedGuarantorEmployemnt
      ) {
        validationResult = false;
      }
      if (!savedGuarantorDocuments) {
        validationCompletion = false;
      }
      if (savedGuarantorData && savedGuarantorDetails) {
        if (savedGuarantorData.guarantor_type == "company") {
          completionResultEmployemnt = true;
          completionResultData = hasKeysAndNotEmpty(
            savedGuarantorData,
            RequiredFields.guarantor_data_company
          );
        } else {
          completionResultData = hasKeysAndNotEmpty(
            savedGuarantorData,
            RequiredFields.guarantor_data_individual
          );
          completionResultEmployemnt = checkValidations(
            savedGuarantorEmployemnt
          );
        }
        let completionResultDetail = checkValidations(savedGuarantorDetails);
        if (savedGuarantorDocuments) {
          if (savedGuarantorData.guarantor_type == "individual") {
            completionResultDocuments = validateRequiredFields(
              savedGuarantorDocuments,
              RequiredFields.applicant_documents
            );
          } else {
            completionResultDocuments = validateRequiredFields(
              savedGuarantorDocuments,
              RequiredFields.company_applicant_documents
            );
          }
        }
        if (
          completionResultData == true &&
          completionResultDetail == true &&
          completionResultEmployemnt == true &&
          completionResultDocuments == true
        ) {
          newPanes.push({
            label: "Guarantor" + newLength,
            children: (
              <Guarantor
                guarantor_index={newLength}
                updateFunction={updateFunction}
                isApplicationGuarantor={isApplicationGuarantor}
                applicationID={applicationID}
                existingGuarantors={existingGuarantors}
              />
            ),
            key: newLength,
          });
          localStorage.setItem("guarantorcount", newPanes.length);
          setItems(newPanes);
          setActiveKey(newLength);
          onChange(newLength);
          return true;
        } else {
          toast.error("Please Complete Previous Guarantor Details");
          return false;
        }
      } else {
        // toast.error("Please Complete Guardian Details");
        return false;
      }
    }
  };
  const remove = (targetKey) => {
    localStorage.removeItem("guarantor_details_" + targetKey);
    localStorage.removeItem("guarantor_personal_details_" + targetKey);
    localStorage.removeItem("guarantor_employement_details_" + targetKey);
    localStorage.removeItem("guarantor_documents_" + targetKey);
    localStorage.removeItem("guarantor_type_" + targetKey);
    localStorage.removeItem("guarantor_id" + targetKey);
    let newActiveKey = activeKey;
    let lastIndex = -1;
    items.forEach((item, i) => {
      if (item.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newPanes = items.filter((item) => item.key !== targetKey);
    if (newPanes.length && newActiveKey === targetKey) {
      if (lastIndex >= 0) {
        newActiveKey = newPanes[lastIndex].key;
      } else {
        newActiveKey = newPanes[0].key;
      }
    }
    localStorage.setItem("guarantorcount", newPanes.length);
    setItems(newPanes);
    setActiveKey(newActiveKey);

    // dispatch(removeGuarantor(targetKey));
  };
  const onEdit = (targetKey, action) => {
    if (action === "add") {
      add();
    } else {
      setRemModal(true);
      setRemTrgt(targetKey);
    }
  };
  const cnfrmRemove = async () => {
    const gId = localStorage.getItem(`guarantor_id_${remTrgt}`);
    const appId = localStorage.getItem("applicationno");
    const tokenId = localStorage.getItem("dealerModuleToken");
    remove(remTrgt);
    setRemModal(false);
    dispatch(removeGuarantorLabelByModal());
    if (gId) {
      const resp = await axios.post(
        `/update/loan/applicant/details/${appId}`,
        {
          removed_guarantors: [gId],
        },
        {
          headers: {
            Authorization: `Bearer ${tokenId}`,
          },
        }
      );
      if (resp) {
        toast.success("Guarantor removed successfully!!!");
      }
    }
  };

  const handleGuarantorClick = () => {
    if (clickAddBtn == true) {
      setItems(initialItems);
      localStorage.setItem("guarantorcount", 1);
      setClickAddBtn(false);
    } else {
      setItems(initialItems);
      localStorage.setItem("guarantorcount", 1);
    }
  }

  useEffect(() => {
    guarantorCountUpdator(items.length);
  }, [items]);

  useEffect(() => {
    let count = JSON.parse(localStorage.getItem("guarantorcount"));
    if (parseInt(count) > 1) {
      let items = [];
      for (let index = 0; index < count; index++) {
        let actualIndex = index + 1;
        items.push({
          label: "Guarantor " + actualIndex,
          children: (
            <Guarantor
              guarantor_index={actualIndex}
              updateFunction={updateFunction}
              isApplicationGuarantor={isApplicationGuarantor}
              applicationID={applicationID}
              existingGuarantors={existingGuarantors}
            />
          ),
          key: actualIndex,
        });
        guarantorCountUpdator(count);
      }
      setItems(items);
    } else if (count == 1) {
      setItems(initialItems);
    }
  }, [existingGuarantors]);


  return (
    <div>
      <Modal
        title={"Remove Guarantor"}
        open={remModal}
        onOk={cnfrmRemove}
        centered
        onCancel={() => setRemModal(false)}
        okText={"Confirm"}
      >
        <p>Are you sure want to remove?</p>
      </Modal>
      {items.length > 0 ? (
        <Tabs
          type="editable-card"
          onChange={onChange}
          // hideAdd
          activeKey={activeKey}
          onEdit={onEdit}
          items={items}
        />
      ) : (
        <div className="text-center">
          <p className="mb-2 border-b border-search-border-color pb-2 font-lato text-[15px]">
            Do you want to add a Guarantor
            <span
              onClick={handleGuarantorClick}
              className="text-step-color-active cursor-pointer"
            >
              &nbsp;+ Add Guarantor
            </span>
          </p>
          <p className="text-color-loan-sub-gray font-lato text-[14px] mt-2">
            Skip this step if you do not have guarantor
          </p>
          <p className="font-lato text-color-loan-sub-gray text-[14px]">
            {" "}
            (If you are a WP Holder / Foreigner, having a local and/or PR
            guarantor will increase the chances of your loan approval)
          </p>
        </div>
      )}
    </div>
  );
};

export default GuarantorTabs;